import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import resolveIcon from '../../../images/resolved.png';
import cross from '../../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import apiClient from "../../../axios";
import jwt from 'jwt-decode';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { confirmAlert } from 'react-confirm-alert';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { Typography, Container, Box } from '@mui/material';


export const PlantConsumptionPopover = (props) => {

  const [logModalOpen, setLogModalOpen] = useState(false);
  const [cofirmMessage, setConfirmMessage] = useState("");

  return (
    <>
      <Container maxWidth="xl">
        <Typography variant='subtitle1' justifyItems='center' alignContent='center' gutterBottom>Please Select Valid Week Number</Typography>
      </Container>
      <Box display='flex' alignItems="center" justifyContent="center" mt={1} style={{ float: "right" }}>
        <Button onClick={props.handleLogModalClose}>Cancel</Button>
      </Box>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={cofirmMessage} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={setLogModalOpen}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
